import React, {useEffect, useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {useForm, Controller} from 'react-hook-form';
import {t} from "i18next";
import { toast } from 'react-toastify';
import {FaInfoCircle} from "react-icons/fa";
import {useHistory} from "react-router-dom";
import {useDefaultEndpoints} from "../../../../lib/api/useDefaultEndpoints";
import {PhoneRHF} from "../../reactHookFormsFields";
import FieldWithValidation from "../../../generic/fields/FieldWithValidation";
import ExperienceSelectField from "../../../generic/fields/ExperienceSelectionField"

const updateParticipantData = (order, participantIndex, data) => {
    const currentParticipantData = order?.participant_data;

    if (Array.isArray(currentParticipantData)) {
        return currentParticipantData.map((participant, index) =>
            index === participantIndex ? { ...participant, ...data } : participant
        );
    } else {
        return { ...currentParticipantData, ...data };
    }
};

const formingRequest = async (defaultOrdersApi, orderId, order, participantIndex, data) => {
    const newParticipantData = updateParticipantData(order, participantIndex, data);

    return defaultOrdersApi.editEntry(orderId, {
        participant_data: newParticipantData
    });
};

const EditUserDataModal = (props) => {
    const {onClose, isOpen, state, orderId, order, updateParticipantData} = props;
    let history = useHistory();
    const {handleSubmit, control, formState: { errors }} = useForm({
        mode: "onChange",
        defaultValues: {
            first_name: state.first_name || '',
            last_name: state.last_name || '',
            email: state.email || '',
            telegram: state?.telegram || '',
            passport_num_ru: state.passport_num_ru || '',
            sailing_experience: state.sailing_experience || '',
            shirt_size: state.shirt_size || '',
        },
    });
    const getShirts = useDefaultEndpoints('shirt-sizes').getEntries;
    const defaultOrdersApi = useDefaultEndpoints('orders');

    const [shirts, setShirts] = useState([]);

    const onSubmit = handleSubmit(async (data) => {
        try {
            await formingRequest(defaultOrdersApi, orderId, order, state.participantIndex, data);
            if (updateParticipantData) {
                updateParticipantData(orderId, state.participantIndex, data);
            }
            toast(t('management.orders.order.modalEdit.success'), {type: 'success'});
            onClose();
        } catch (err) {
            toast(t('management.orders.order.modalEdit.error'), {type: 'error'});
        }
    })

    const toUserProfile = () => {
        if (state?.userId) {
            history.push('/administration/users/edit/' + state.userId);
            onClose();
        }
    };

    useEffect(() => {
        getShirts({}).then(res => setShirts(() => res));
    }, [])

    return (
        <Modal isOpen={isOpen} toggle={onClose} className={props.className} unmountOnClose>
            <ModalHeader>
                {props.title}
            </ModalHeader>
            <ModalBody>
                <Form>
                    <Row className={'align-items-end'}>
                        <Col xs={12} md={6} lg={6}>
                            <FormGroup>
                                <Label for="first_name">{t('management.users.name')}</Label>
                                <Controller
                                    control={control}
                                    name={"first_name"}
                                    render={({ value, onChange }) => (
                                        <Input
                                            value={value}
                                            onChange={onChange}
                                            type="text"
                                            id="first_name"
                                            placeholder={t('management.users.namePlaceholder')}
                                        />
                                    )}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                            <FormGroup>
                                <Label for="last_name">{t('management.users.surname')}</Label>
                                <Controller
                                    control={control}
                                    name={"last_name"}
                                    render={({ value, onChange }) => (
                                        <Input type="text"
                                               id="last_name"
                                               placeholder={t('management.users.surnamePlaceholder')}
                                               value={value}
                                               onChange={onChange}
                                        />
                                    )}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className={'align-items-end'}>
                        <Col xs={12} md={6} lg={6}>
                            <FormGroup>
                                <Controller
                                    control={control}
                                    name="email"
                                    render={(
                                        {value, onBlur, name, ref, onChange},
                                        {invalid}
                                    ) =>
                                        <FieldWithValidation invalid={invalid} errors={errors} label={t('management.users.mail')}
                                                             name={name} isRequired={false}
                                                             type="text" onBlur={onBlur} value={value} placeholder="example@bask.ws"
                                                             onChange={e => {
                                                                 onChange(e.target.value)
                                                             }}
                                        />
                                    }
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                            <FormGroup>
                                <Label for="telegram">Telegram</Label>
                                <Controller
                                    name={"telegram"}
                                    control={control}
                                    render={({ value, onChange }) => (
                                        <Input type={'text'}
                                               id="telegram"
                                               placeholder={'@silavetrasila'}
                                               value={value}
                                               onChange={onChange}
                                        />
                                    )}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className={'align-items-end'}>
                        <Col xs={12} md={6} lg={6}>
                            <FormGroup>
                                <Label for="passport_num_ru">{t('management.users.passportNumRu')}</Label>
                                <Controller
                                    name={"passport_num_ru"}
                                    control={control}
                                    render={({ value, onChange }) => (
                                        <Input type="text"
                                               id="passport_num_ru"
                                               value={value}
                                               onChange={onChange}
                                        />
                                    )}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                            <ExperienceSelectField
                                control={control}
                                name="sailing_experience"
                                errors={errors}
                            />
                        </Col>
                    </Row>
                    <Row className={'align-items-end'}>
                        <Col className={'col-auto'}>
                            <FormGroup>
                                <PhoneRHF form={{control, errors}} state={state} isRequired={false}
                                          name={'phone'}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={3}>
                            <FormGroup>
                                <Label for="shirt_size">{t('management.users.shirtSize')}</Label>
                                <Controller
                                    name={"shirt_size"}
                                    control={control}
                                    render={({ value, onChange }) => (
                                        <Input type="select"
                                               id="shirt_size"
                                               value={value}
                                               onChange={onChange}
                                        >
                                            <option value={''} disabled>{t('management.users.size')}</option>
                                            {shirts.map(shirt => <option value={shirt.tag} key={shirt.tag}>{shirt.tag}</option>)}
                                        </Input>
                                    )}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
                <FaInfoCircle className='ml-1' id={"mail_sent_i"}/> {props.text}
            </ModalBody>
            <ModalFooter>
                <Row className={'align-items-center justify-content-end'}>
                    <Col className={'col-auto'}>
                        <Button color="primary" size={'sm'} className={'btn-rounded'} onClick={toUserProfile}>
                            {t('management.orders.order.modalEdit.toUserProfile')}
                        </Button>
                    </Col>
                    <Col className={'col-auto'}>
                        <Button color="success" size={'sm'} className={'btn-rounded'} onClick={handleSubmit(onSubmit)}>
                            {t('management.orders.order.modalEdit.save')}
                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default EditUserDataModal;